import React from "react";
import { ContactSec } from "../ui/contact-sec";

export const Contact = () => (
  <>
    <ContactSec />
  </>
);
